/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: HttpRequest.ts
 * Created by: Kevin
 * Create Date: 2022-12-09 18:19
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import ApiUrlBuilder from "@/commons/https/ApiUrlBuilder";
import axios, {AxiosInstance, CancelTokenSource, CreateAxiosDefaults} from "axios";
import AppConfig from "@/commons/AppConfig";
import HttpTokenProvider from "@/commons/https/HttpTokenProvider";
import HttpRequestConfig from "@/commons/https/HttpRequestConfig";

export abstract class HttpRequest {

    protected apiUrlBuilder: ApiUrlBuilder;
    protected cancelSource: CancelTokenSource;
    protected requestConfig: HttpRequestConfig;

    protected constructor(apiUrlBuilder: ApiUrlBuilder, reqCfg: HttpRequestConfig | null) {
        this.apiUrlBuilder = apiUrlBuilder
        this.cancelSource = axios.CancelToken.source();
        this.requestConfig = this.ensureRequestConfig(reqCfg);
        this.requestConfig.withCredentials = true
    }

    public abstract getTargetURL(): string;

    public abstract execute(token?: HttpTokenProvider | null): Promise<any>;

    public cancel(reason: string) {
        this.cancelSource.cancel(reason);
    }

    protected resolveEnvFormData(): any {
        // The FormData class to be used to automatically serialize the payload into a FormData object
        return window?.FormData || global?.FormData
    }

    protected resolveDefaultRequestConfig(): HttpRequestConfig {
        return {
            withCredentials: true,
            cancelToken: this.cancelSource.token,
            timeout: AppConfig.Instance.apiDefaultTimeout,
            env: {
                FormData: this.resolveEnvFormData()
            }
        };
    }

    protected ensureRequestConfig(cfg: HttpRequestConfig | null): HttpRequestConfig {
        if (cfg == null) {
            return this.resolveDefaultRequestConfig();
        } else {
            cfg.withCredentials = true;
            cfg.cancelToken = this.cancelSource.token;
            cfg.retryCount = 0;
            cfg.env = {
                FormData: this.resolveEnvFormData()
            };
            return cfg;
        }
    }

    protected createAxios(cfg?: CreateAxiosDefaults): AxiosInstance {
        let inst = axios.create(cfg)
        inst.defaults.timeout = AppConfig.Instance.apiDefaultTimeout;
        return inst;
    }

} // end class - HttpExecutor